import BaseModel from './BaseModel'

export default class Bank extends BaseModel {
  // ... Bank-specific methods or overrides ...
}
